import { Component } from 'react';
import Zendesk from 'common/util/Zendesk/Zendesk';
import styles from './SupportWidget.scss';

const landingPageSupportSettings = {
    helpCenter: { suppress: true },
    position: {
        horizontal: 'right',
        vertical: 'bottom'
    }
};

class LandingPageSupport extends Component {

    constructor(props) {
        super(props);
        this.zendesk = null;
        this.state = { hidden: true };
    }

    componentWillUnmount() {
        const { zendesk } = this;
        zendesk.removeWidget();
    }

    componentDidMount() {
        this.zendesk = new Zendesk();
        this._setSupportWidgetSettings();
        this.zendesk.loadWidget()
            .then(() => {
                this._setSupportWidgetStyles();
            });

    }

    _setSupportWidgetSettings() {
        const { zendesk } = this;
        zendesk.setWidgetSettings(landingPageSupportSettings);
    }

    _setSupportWidgetStyles() {
        const { zendesk } = this;

        zendesk.addClassToWidgetIframe(styles.supportWidgetDropdown);
        const widgetLabelStyles = 'font-size: 1.4rem; font-weight: 400; padding-right: 0.7rem;';
        zendesk.addStylesToWidgetLabel(widgetLabelStyles);
        zendesk.hideWidgetLabelIcon();
        zendesk.showWidgetDefaultButton();
    }

    render() {
        return null;
    }
}

export default LandingPageSupport;
